export default __webpack_public_path__ + "media/images/images_v2/bar2-c3eb1464920d8397c073c3bf7d970b2d.png";